import styled from "styled-components";
import {
  ArrowPointLeft,
  PersonSolid,
  color,
  palette,
  spacing,
  opacity,
} from "@conserveit/blocks";

export const Container = styled.div`
  padding: ${spacing.loose};
`;

export const ID = styled.h1`
  margin: 0;
  padding: 0;
  font-size: 16px;
  color: ${palette.neutral6};

  strong {
    display: inline-block;
    margin-right: ${spacing.tight};
    font-weight: 600;
    color: ${color.theme.typography.ink};
  }
`;

// TODO: These any assertions are a result of TS infering that `className` is a
// required prop. This should be fixed up later with @bueno/blocks
export const StyledAvatar = styled(PersonSolid)`
  margin-right: ${spacing.tight};
`;

export const StyledArrowBack = styled(ArrowPointLeft as any)<{
  priority?: string;
}>`
  display: inline-block;
  width: 16px;
  transform: rotate(90deg);
  fill: ${(props) =>
    props.priority === "Critical" ? palette.red7 : palette.neutral7};
  margin-right: ${spacing.tight};
`;

export const Summary = styled.h2`
  margin: 0 0 ${spacing.tight};
  padding: 0;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: ${color.theme.typography.ink};
`;

export const Updated = styled.span`
  display: flex;
  justify-content: space-between;
  margin: 0 0 ${spacing.default};
  padding: 0 0 ${spacing.default};
  border-bottom: 1px solid ${palette.neutral4};
  font-size: 12px;
  color: ${palette.neutral7};
`;

export const Description = styled.div`
  margin: 0 0 ${spacing.default};
  padding: 0 0 ${spacing.default};
  border-bottom: 1px solid ${palette.neutral4};
  color: ${color.theme.typography.ink};
`;

export const Status = styled(Summary)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 14px;
`;

export const Unselected = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  text-align: center;
  opacity: ${opacity.subtle};
`;
